"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Variables_1 = require("./Variables");
function callParams(params, val) {
    return params(val);
}
function getParams(params, queryParams) {
    if (typeof params === 'function') {
        return callParams(params, queryParams);
    }
    return params;
}
exports.getParams = getParams;
function isValidParams(params) {
    return (typeof params === 'function' || typeof params === 'object');
}
exports.isValidParams = isValidParams;
function findVariables(params, callback) {
    if (!params || typeof params !== 'object') {
        return false;
    }
    Object.entries(params).forEach(function (_a) {
        var _ = _a[0], v = _a[1];
        if (typeof v === 'object') {
            if (v instanceof Variables_1.VariableModel) {
                callback(v);
            }
            else {
                findVariables(v, callback);
            }
        }
    });
}
exports.findVariables = findVariables;
//# sourceMappingURL=Params.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typegraph/dist/util/Params.js
// module id = 788
// module chunks = 0